import React from "react";
import { useTranslation } from "react-i18next";
import Button from "./Button";
import { Link } from "react-router-dom";

const InfoBanner = () => {
  const { t } = useTranslation();
  return (
    <div className="py-10 sm:py-16 px-4 text-center text-[#223746]">
      <p className="text-lg sm:text-2xl">{t("infoBanner.kicker")}</p>
      <p className="text-2xl sm:text-3xl lg:text-4xl font-bold mt-5">
        {t("infoBanner.title")}
      </p>
      <p className="w-full sm:w-2/3 mx-auto my-6 sm:my-10 text-sm sm:text-base">
        {t("infoBanner.body")}
      </p>
      <Link to="/about">
        <Button title={t("infoBanner.cta")} />
      </Link>
    </div>
  );
};

export default InfoBanner;
